import { AppState } from "../states";

export const WatchFormSelectors = {
  watchform(state: AppState) {
    return state.watchform;
  },
};
